import { WorkModel } from '@Entities/work/work'

export const getCurrentMemberShares = (workDraftLocal: WorkModel, currentRightsholderIpId: number) => {
    let currentRightsholderTotalShares = 0
    workDraftLocal.originalPublishers.map((op) => {
        if (op.topMemberIpId === currentRightsholderIpId && op.publisherShare) {
            currentRightsholderTotalShares += op.publisherShare
        }
        op.administratorPublishers.map((ap) => {
            if (ap.topMemberIpId === currentRightsholderIpId && !!ap.publisherShare) {
                currentRightsholderTotalShares += ap.publisherShare
            }
        })
    })
    return currentRightsholderTotalShares
}
